import { Grid, Tooltip } from '@material-ui/core';
import React from 'react';
import { statusMapper } from '../job-status';
import { humanJobType, toAccount, toAccountGroupName, toProperty } from '../utils';
import { Tick } from 'components/reusable/tick';
import { humanDate, humanPhone } from 'utils/ui.utils';
export const getJobsColumns = (isAdmin, accounts, accountGroups) => {
    const jobsColumns = [
        {
            xs: 1,
            name: 'Status',
            customRenderValue: (item) => {
                const { status, result } = item;
                // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                const success = !!(result?.successWithSuggestion || result?.success);
                const { reviewSuccess } = item;
                const warnings = item.result?.warnings;
                const { state, label } = statusMapper(status, success, warnings);
                return (React.createElement(Grid, { container: true, item: true, spacing: 0, xs: 12 },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement("div", { style: {
                                display: 'flex',
                                marginTop: '2px',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center'
                            } },
                            reviewSuccess !== null && (React.createElement(Tooltip, { title: reviewSuccess ? 'Review: approved' : 'Review: rejected' },
                                React.createElement("div", null,
                                    React.createElement(Tick, { state: reviewSuccess ? 'approved' : 'rejected', style: {} })))),
                            React.createElement(Tooltip, { title: label },
                                React.createElement("div", null,
                                    React.createElement(Tick, { state: state, style: {} })))))));
            },
            showMobile: true
        },
        {
            xs: 2,
            name: 'Id',
            customRenderValue: (item) => {
                const { id, accountGroupSid } = item;
                const internalId = toProperty('Internal Id', item);
                let account = null;
                if (isAdmin) {
                    account = toAccount(item, accounts);
                }
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "text-ellipsis" }, id),
                    React.createElement("div", { className: "text-ellipsis" }, humanJobType(item)),
                    React.createElement("div", { className: "text-ellipsis" }, account ? account.name : null),
                    React.createElement("div", { className: "text-ellipsis" }, toAccountGroupName(accountGroupSid, accountGroups)),
                    React.createElement("div", { className: "text-ellipsis" }, internalId)));
            },
            showMobile: true
        },
        {
            xs: 2,
            name: 'Name',
            customRenderValue: (item) => {
                let first = toProperty('First Name', item);
                let last = toProperty('Last Name', item);
                if (!first && !last) {
                    first = item.request.parameters?.firstName;
                    last = item.request.parameters?.lastName;
                }
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "text-ellipsis" }, first),
                    React.createElement("div", { className: "text-ellipsis" }, last)));
            },
            showMobile: true
        },
        {
            xs: 2,
            name: 'Contact',
            customRenderValue: (item) => {
                let phone = toProperty('Phone', item);
                let email = toProperty('Email', item);
                if (!phone && !email) {
                    phone = item.request.parameters?.phone;
                    email = item.request.parameters?.email;
                }
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "text-ellipsis" }, humanPhone(phone)),
                    React.createElement("div", { className: "text-ellipsis" }, email)));
            }
        },
        {
            xs: 2,
            name: 'Document',
            customRenderValue: (item) => {
                const first = item.result?.firstName;
                const last = item.result?.lastName;
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "text-ellipsis" }, first),
                    React.createElement("div", { className: "text-ellipsis" }, last)));
            }
        },
        {
            xs: 1,
            name: 'Reviewed',
            id: 'accountReviewed'
        },
        {
            xs: 2,
            name: 'Dates',
            className: '',
            customRenderValue: (item) => {
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "job-date" }, humanDate(item.submitted)),
                    React.createElement("div", { className: "job-date" }, humanDate(item.updatedAt))));
            },
            showMobile: true
        }
    ];
    return jobsColumns;
};
